module.exports = __webpack_public_path__ + "static/tablet-membership-ec8c72ae91e8cc1172a21e72892feddf.png";